import BaseInteractionService from '@configuratorware/configurator-frontendgui/App/Services/InteractionService';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { SaveTypes } from '@configuratorware/configurator-frontendgui/App/configuration';
import { EventTypes } from '@configuratorware/configurator-frontendgui/App/Constant';

class InteractionService extends BaseInteractionService {
  async sendReceiveOfferRequest() {
    try {
      await Services.configurator.captureAndSaveConfiguration(SaveTypes.OFFERREQUEST);
      Services.analytics.triggerEvent(EventTypes.selected_amounts);
    } catch (e) {
      Services.ui.reportError(t('receiveOfferForm.sentError'));
      return false;
    }
    const { code } = Services.configurator.state.configuration;
    try {
      window.parent.postMessage({ method: 'addToRequestList', code:  code}, '*')
    } catch (error) {
      Services.ui.reportError(t('receiveOfferForm.sentError'));
      return false;
    }

    return true;
  }
}

export default InteractionService;
